import React, { Component } from 'react';
import Lightbox from 'react-image-lightbox';
import MoreWorkSlider from 'react-slick';
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { nextArrow } from '../Arrows';
import createGroupedArray from '../../util/createGroupedArray';
import shuffleArray from '../../util/shuffleArray';
import styles from './styles.scss';
import andrew1 from './assets/andrew_1.gif';
import andrew2 from './assets/andrew_2.gif';
import andrew3 from './assets/andrew_3.gif';
import ben1 from './assets/ben_1.png';
import ben2 from './assets/ben_2.png';
import ben3 from './assets/ben_3.gif';
import camilo1 from './assets/camilo_1.jpg';
import camilo2 from './assets/camilo_2.jpg';
import camilo3 from './assets/camilo_3.gif';
import charlene1 from './assets/charlene_1.png';
import charlene2 from './assets/charlene_2.png';
import charlene3 from './assets/charlene_3.gif';
import charlene4 from './assets/charlene_4.jpg';
import charlene5 from './assets/charlene_5.gif';
import charlene6 from './assets/charlene_6.png';
import dennis1 from './assets/dennis_1.png';
import dennis2 from './assets/dennis_2.png';
import dennis3 from './assets/dennis_3.png';
import dennis4 from './assets/dennis_4.png';
import ellie1 from './assets/ellie_1.png';
import ellie2 from './assets/ellie_2.png';
import preston1 from './assets/preston_1.png';
import preston2 from './assets/preston_2.png';
import preston3 from './assets/preston_3.png';

const images = [
  {
    artist: 'Charlene Foote',
    experience: 'experience + visual designer',
    image: charlene1
  },
  {
    artist: 'Charlene Foote',
    experience: 'experience + visual designer',
    image: charlene2
  },
  {
    artist: 'Charlene Foote',
    experience: 'experience + visual designer',
    image: charlene3
  },
  {
    artist: 'Charlene Foote',
    experience: 'experience + visual designer',
    image: charlene4
  },
  {
    artist: 'Charlene Foote',
    experience: 'experience + visual designer',
    image: charlene5
  },
  {
    artist: 'Charlene Foote',
    experience: 'experience + visual designer',
    image: charlene6
  },
  {
    artist: 'Dennis Corte\'s',
    experience: 'branding + visual designer',
    image: dennis1
  },
  {
    artist: 'Dennis Corte\'s',
    experience: 'branding + visual designer',
    image: dennis2
  },
  {
    artist: 'Dennis Corte\'s',
    experience: 'branding + visual designer',
    image: dennis3
  },
  {
    artist: 'Dennis Corte\'s',
    experience: 'branding + visual designer',
    image: dennis4
  },
  {
    artist: 'Ben Wallace',
    experience: 'branding + visual designer',
    image: ben1
  },
  {
    artist: 'Ben Wallace',
    experience: 'branding + visual designer',
    image: ben2
  },
  {
    artist: 'Ben Wallace',
    experience: 'branding + visual designer',
    image: ben3
  },
  {
    artist: 'Andrew Munoz',
    experience: 'experience + visual designer',
    image: andrew1
  },
  {
    artist: 'Andrew Munoz',
    experience: 'experience + visual designer',
    image: andrew2
  },
  {
    artist: 'Andrew Munoz',
    experience: 'experience + visual designer',
    image: andrew3
  },
  {
    artist: 'Camilo Bejarano',
    experience: 'animator + illustrator',
    image: camilo1
  },
  {
    artist: 'Camilo Bejarano',
    experience: 'animator + illustrator',
    image: camilo2
  },
  {
    artist: 'Camilo Bejarano',
    experience: 'animator + illustrator',
    image: camilo3
  },
  {
    artist: 'Ellie Borromeo',
    experience: 'branding + visual designer',
    image: ellie1
  },
  {
    artist: 'Ellie Borromeo',
    experience: 'branding + visual designer',
    image: ellie2
  },
  {
    artist: 'Preston Attebery',
    experience: 'branding + visual designer',
    image: preston1
  },
  {
    artist: 'Preston Attebery',
    experience: 'branding + visual designer',
    image: preston2
  },
  {
    artist: 'Preston Attebery',
    experience: 'branding + visual designer',
    image: preston3
  }
];

const sliderSettings = {
  variableWidth: true,
  slidesToScroll: 1,
  infinite: true,
  nextArrow: nextArrow(),
  responsive: [
    {
      breakpoint: 419,
      settings: {
        variableWidth: false,
        slidesToShow: 1
      }
    }
  ]
}

class MoreWork extends Component {
  constructor(props) {
    super(props);

    this.state = {
      imageSrc: '',
      photoIndex: 0,
      shuffledImages: [],
      isOpen: false
    };
  }

  render() {
    const {
      photoIndex,
      imageSrc,
      isOpen,
      shuffledImages
    } = this.state;

    // 3 Panes vertically stacked per slide
    // Panes contain an image, artist, and experience property
    const slides = createGroupedArray(shuffledImages, 3).map((panes, index) => {
      return (
        <div className={styles.slide} key={index}>
          {panes.map((pane, i) => {
            return (
              <div className={styles.workPanel} onClick={() => {this.openLightbox(pane.image)}} key={i}>
                <img className={styles.panelImage} src={pane.image} alt={`by ${pane.artist}`} />
                <div className={styles.artistInfo}>
                  <span className="bold">
                    {pane.artist}
                  </span>
                  <span className="alt-text">
                    {pane.experience}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      );
    });

    return (
      <div className={`${styles.moreWorkSlider} row`}>
        <div className="col-md-12">
          <MoreWorkSlider {...sliderSettings}>
            {slides}
          </MoreWorkSlider>
          <div className={styles.nextArrowBackdrop} />
          { isOpen &&
            <Lightbox
              mainSrc={imageSrc || images[(photoIndex)].image}
              nextSrc={images[(photoIndex + 1) % images.length].image}
              prevSrc={images[(photoIndex + images.length - 1) % images.length].image}

              onCloseRequest={() => this.setState({ isOpen: false })}
              onMovePrevRequest={() => this.setState({
                imageSrc: null,
                photoIndex: (photoIndex + images.length - 1) % images.length
              })}
              onMoveNextRequest={() => this.setState({
                imageSrc: null,
                photoIndex: (photoIndex + 1) % images.length
              })}
            />
          }
        </div>
      </div>
    );
  }

  componentWillMount() {
    const shuffledImages = shuffleArray(images);
    this.setState({shuffledImages});
  }

  openLightbox = (imageSrc) => {
    this.setState({
      imageSrc,
      isOpen: true
    });
  }
}

export default MoreWork;



// WEBPACK FOOTER //
// ./src/components/MoreWork/index.js